import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Modal from '../../containers/modal';
import { useViewport } from '../../hooks/useViewport';
import Card from './MealReservationCard';
import './index.scss';
import { PrebookModalHeader } from './AvengersDoomsday';
import Icon from './Icon';
import Loader from '../loader-spin';
import {
  getPrebookInfo,
  redeemPrebook,
  togglePrebookModal
} from '../../burger-king-lib/redux/home/actions';
import useBKLocation from '../../hooks/useBKLocation';
import RestaurantOrderType from '../restaurant-order-type';
import { LocalSessionKey } from '../../burger-king-lib/constants/app-constants';
import YourProduct from './YourProduct';
import YourOrder from './YourOrder';
import { CountdownTimer, MealButton } from './molecules';
import { ROUTES } from '../../constants/app-constants';

const PreebookRedeem = ({ onClose, onAddToCart }) => {
  const { location } = useBKLocation();
  const { preBookInfo: preBook, isPrebookModalOpened } = useSelector(
    state => state.home
  );

  const dispatch = useDispatch();

  const handleClose = () => {
    if (typeof onClose === 'function') onClose();
  };

  const handleReedeem = () => {
    if (typeof onAddToCart === 'function') onAddToCart();
  };

  useEffect(() => {
    if (!isPrebookModalOpened) return;

    if (!preBook) {
      dispatch(getPrebookInfo());
    }
  }, []);

  return (
    <>
      <PrebookModalHeader title="Your pre-booking" onGoBack={handleClose} />
      {!preBook ? (
        <Loader />
      ) : (
        <div className="pre-book-status-model__outer-wrapper">
          <Card className="meal-card">
            <Card.Image />
            <div className="inner-wrapper">
              <div>
                <Card.Chip>{preBook.status}</Card.Chip>
                <Card.Heading>
                  Your meal is {(preBook?.status || '').toLowerCase()}
                </Card.Heading>
                <Card.Description>{preBook?.productName}</Card.Description>
              </div>
              {!preBook.isRedeemStarted && (
                <CountdownTimer endDate={preBook.unLocksAt} />
              )}
            </div>
          </Card>
          <section className="checkout-total" aria-label="Payment summary">
            <div className="checkout-total__payable">
              <span>Pre-book ID</span>
              <span>{preBook?.preBookID}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Account</span>
              <span>{preBook?.mobileNumber}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Amount paid</span>
              <span>₹ {preBook?.amount}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Unlocks</span>
              <span>{preBook.unLocksAt}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Valid until</span>
              <span>{preBook.redeemUntil}</span>
            </div>
            <div className="checkout-total__payable">
              <span>Fulfilment</span>
              <span>Dine-in only</span>
            </div>
          </section>
          <MealButton
            size="sm"
            className="navigation"
            endIcon={<Icon name="leftArrow" className="icon" />}
          >
            Pre-book terms and refund policy
          </MealButton>

          {preBook.isRedeemStarted && (
            <div className="pre-book-status-model__location-button-con">
              {/* <LocationCard location={location} /> */}
              <MealButton className="restaurant-button" onClick={handleReedeem}>
                REDEEM AT THIS RESTAURANT
              </MealButton>
            </div>
          )}
        </div>
      )}
    </>
  );
};

const PreMealOrderStatusModal = ({ onClose }) => {
  const { isMobile } = useViewport();
  const [activeScreen, setActiveScreen] = useState('redeem');
  const { preBookInfo: preBook, isPrebookModalOpened } = useSelector(
    state => state.home
  );
  const { location } = useBKLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const [orderType, setOrderType] = useState('restaurant');
  const handleClose = () => {
    if (typeof onClose === 'function') onClose();
  };

  const handleSetCartScreen = () => {
    setActiveScreen('cart');
  };

  const handleOrderTypeHandler = value => {
    setOrderType(value);
  };

  const theme = sessionStorage.getItem(LocalSessionKey.THEME);
  const handleSuccess = () => {
    dispatch(togglePrebookModal());
    history.push({ pathname: ROUTES.ORDER_STATUS, search: '?type=pre-book' });
  };

  const handleRedeem = () => {
    const payload = {
      outlet_id: sessionStorage.getItem(LocalSessionKey.OUTLET_ID)
    };
    dispatch(redeemPrebook(payload, { success: handleSuccess }));
  };

  useEffect(() => {
    if (!isPrebookModalOpened) return;

    if (!preBook) {
      dispatch(getPrebookInfo());
    }
  }, [isPrebookModalOpened]);

  const renderContent = () => {
    const status = preBook?.status;

    if (status === 'RESERVED' && !preBook?.isRedeemStarted) {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            <YourProduct.ImageCard
              status={status}
              description={preBook?.productName}
              heading="Your meal is reserved"
              isCountDownVisible={!preBook?.isRedeemStarted}
              unLocksAt={preBook?.unLocksAt}
            />
            <YourProduct.BookingInfoCard
              amount={preBook?.amount}
              preBookID={preBook?.preBookID}
              mobileNumber={preBook?.mobileNumber}
              redeemUntil={preBook?.redeemUntil}
              unLocksAt={preBook.unLocksAt}
            />
            <YourProduct.TermsButton />
          </YourProduct>
        </div>
      );
    }

    if (
      status === 'RESERVED' &&
      preBook?.isRedeemStarted &&
      activeScreen === 'redeem'
    ) {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            <YourProduct.ImageCard
              status="READY TO REDEEM"
              description={preBook?.productName}
              heading="Your meal is reserved"
              isCountDownVisible={!preBook?.isRedeemStarted}
              unLocksAt={preBook?.unLocksAt}
            />
            <YourProduct.BookingInfoCard
              amount={preBook?.amount}
              preBookID={preBook?.preBookID}
              mobileNumber={preBook?.mobileNumber}
              redeemUntil={preBook?.redeemUntil}
              unLocksAt={preBook.unLocksAt}
            />
            <YourProduct.TermsButton />
            <YourProduct.LocationCard
              className="pre-book-status-model__location"
              location={location}
            />
            <YourProduct.RedeemButton onClick={handleSetCartScreen} />
          </YourProduct>
        </div>
      );
    }

    if (
      status === 'RESERVED' &&
      preBook?.isRedeemStarted &&
      activeScreen === 'cart'
    ) {
      return (
        <YourOrder>
          <YourOrder.Wrapper>
            <>
              <YourOrder.Info>WHAT IS YOUR ORDER TYPE</YourOrder.Info>
              <RestaurantOrderType
                type={orderType}
                onChange={handleOrderTypeHandler}
                leftValue="restaurant"
                rightValue="takeaway"
                theme={theme}
              />
              <YourOrder.Description />
              <YourOrder.DescriptionTwo />
              <YourProduct.LocationCard location={location} />
            </>
          </YourOrder.Wrapper>
          <YourOrder.Footer onClick={handleRedeem}>
            Checkout - ₹0.00
          </YourOrder.Footer>
        </YourOrder>
      );
    }

    if (status === 'REDEEMED') {
      return (
        <YourOrder>
          <YourOrder.Wrapper>
            <>
              <YourOrder.Info>WHAT IS YOUR ORDER TYPE</YourOrder.Info>
              <RestaurantOrderType
                type={orderType}
                onChange={handleOrderTypeHandler}
                leftValue="restaurant"
                rightValue="takeaway"
                theme={theme}
              />
              <YourOrder.Description />
              <YourOrder.DescriptionTwo />
              <YourProduct.LocationCard location={location} />
            </>
          </YourOrder.Wrapper>
        </YourOrder>
      );
    }

    if (status === 'EXPIRED') {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            <YourProduct.ImageCard
              status={status}
              description={preBook?.productName}
              heading="Redemption window ended"
              isCountDownVisible={!preBook?.isRedeemStarted}
              unLocksAt={preBook?.unLocksAt}
            />
            <YourProduct.BookingInfoCard
              amount={preBook?.amount}
              preBookID={preBook?.preBookID}
              mobileNumber={preBook?.mobileNumber}
              redeemUntil={preBook?.redeemUntil}
              unLocksAt={preBook.unLocksAt}
            />
            <YourProduct.TermsButton />
          </YourProduct>
        </div>
      );
    }

    if (status === 'PENDING_PAYMENT') {
      return (
        <div className="pre-book-status-model__outer-wrapper">
          <YourProduct>
            <YourProduct.ImageCard
              status="PAYMENT PENDING"
              description={preBook?.productName}
              heading="Payment Confirmation Pending"
              isCountDownVisible={!preBook?.isRedeemStarted}
              unLocksAt={preBook?.unLocksAt}
            />

            <YourProduct.TermsButton />
          </YourProduct>
        </div>
      );
    }

    return (
      <div className="pre-book-status-model__outer-wrapper">
        <Loader />
      </div>
    );
  };

  const getHeaderTitle = () => {
    const status = preBook?.status;

    if (
      (status === 'RESERVED' && activeScreen === 'cart') ||
      status === 'REDEEMED'
    )
      return 'Your order';

    return 'Your pre-booking';
  };

  return (
    <Modal
      isMobileFullLayout={isMobile}
      hideClose
      customClass="pre-book-status-model__custom-class"
      modalCustomClass="pre-book-status-model"
      contentCustomClass="pre-book-status-model__modal-wrapper"
      onCloseHandler={handleClose}
      width="375px"
    >
      {/* {activeScreen === 'redeem' ? (
        <PreebookRedeem
          onClose={handleClose}
          onAddToCart={handleSetCartScreen}
        />
      ) : (
        <PrebookOrderCart />
      )} */}
      <>
        <PrebookModalHeader title={getHeaderTitle()} onGoBack={handleClose} />
        {renderContent()}
      </>
    </Modal>
  );
};

export default PreMealOrderStatusModal;
